module.exports = __webpack_public_path__ + "static/media/filled-star.86c19d29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filled-star.svg
// module id = 120
// module chunks = 0